__turbopack_context__.v({
  "heartIcon": "PhotographerMedias-module__wDPCaG__heartIcon",
  "liked": "PhotographerMedias-module__wDPCaG__liked",
  "mediaContent": "PhotographerMedias-module__wDPCaG__mediaContent",
  "mediaLikes": "PhotographerMedias-module__wDPCaG__mediaLikes",
  "mediaPicture": "PhotographerMedias-module__wDPCaG__mediaPicture",
  "mediasGrid": "PhotographerMedias-module__wDPCaG__mediasGrid",
  "sideInfos": "PhotographerMedias-module__wDPCaG__sideInfos",
  "tags": "PhotographerMedias-module__wDPCaG__tags",
  "tagsSelect": "PhotographerMedias-module__wDPCaG__tagsSelect",
});
